import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareListRoute: InvariantJiraRoute = {
	name: 'software-list',
	path: '/jira/software/projects/:projectKey/list/:navigationItemId?',
};
